import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Puerto de solo lectura del estado de autenticación.
 * Los guards y el tokenInterceptor dependen de esta abstracción,
 * no de AuthService directamente — respeta DIP y permite
 * cambiar el proveedor de identidad sin tocar las piezas transversales.
 */
export interface AuthSessionPort {
  isAuthenticated(): boolean;
  getAccessToken(): string | null;
  logout(): Observable<void>;
}

export const AUTH_SESSION_PORT = new InjectionToken<AuthSessionPort>(
  'AUTH_SESSION_PORT',
);
